// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"65281a2e","838":"71cc2f04"}[chunkId] + ".js";
};